<template>
  <img src="@/assets/images/logo.svg" alt="logo" />
</template>
